<template>
  <b-modal size="xl" centered  scrollable id="modal-type" ref="modal-type" :title="modalTitle" @hidden="resetForm">
    <b-form>
      <b-form-group label="Catégorie" label-for="categorieSelect">
        <b-form-select
          id="categorieSelect"
          :plain="true"
          :options="categoryOptions"
          v-model="selectedCategory"
          :class="{hasError: errors.categorie_id !== ''}">
          <b-form-select-option :value="null">Sélectionnez une catégorie</b-form-select-option>
        </b-form-select>
        <span class="field-error">{{ errors.categorie_id }}</span>
      </b-form-group>
      <b-form-group
          label='Libellé'
          label-for='libelle'
        >
        <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
        <span class="field-error">{{ errors.libelle }}</span>
      </b-form-group>
      <b-form-group
          description='En minuscule sans accent ni espace (mettre un _ à la place)'
          label='Libellé technique'
          label-for='libelle_technique'
        >
        <b-form-input id='libelle_technique' type='text' v-model="libelle_technique" :disabled="!isEmpty(selectedType)" :class="{hasError: errors.libelle_technique !== ''}"></b-form-input>
        <span class="field-error">{{ errors.libelle_technique }}</span>
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          size="md"
          class="float-left"
          @click="resetForm; $bvModal.hide('modal-type')"
        >
          Fermer
        </b-button>
        <b-button type="button" @click="submitForm" size="md" variant="primary" class="float-right">
          <i class="fa fa-save"></i> Enregistrer
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
 
<script>
  import {isEmpty} from "@/utils/fileHelper";
 
export default {
  props: {
    selectedType: {
      type: Object
    },
    categoryOptions: {
      type: Array
    }
  },
  data() {
    return {
      isEmpty,
      libelle: '',
      libelle_technique: '',
      categorie_id: '',
      modalTitle: 'Création d\'un type de document',
      selectedCategory: null,
      errors: {
        libelle: '',
        libelle_technique: '',
        categorie_id: '',
      }
    }
  },
  watch: {
    selectedType(value) {
      if (!isEmpty(value)) {
        this.modalTitle = 'Modification du type de document';
        this.libelle = this.selectedType.libelle;
        this.libelle_technique = this.selectedType.libelle_technique;
        this.selectedCategory = this.selectedType.categorie_id;
      }
    },
  },
  methods: {
    submitForm() {
      if (this.validateData()) {
        let self = this;
        let dataPost = {};

        dataPost.libelle = this.libelle;
        dataPost.libelle_technique = this.libelle_technique;
        dataPost.categorie_id = this.selectedCategory;
        dataPost.typeId = !isEmpty(this.selectedType) ? this.selectedType.id : '';

        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceBibliotheque/type", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$refs['modal-type'].hide();
            this.resetForm();
            // this.getTypes();
            this.$event.emit('refresh-type-document');
            this.$event.emit('refresh-after-new-type', response.data.type);
            let title = !isEmpty(this.selectedType) ? 'Modification avec succès' : 'Création avec succès';
            let texte = !isEmpty(this.selectedType) ? 'Le type de document a bien été modifié' : 'Le type de document a bien été créé';
            this.$swal({
              position: "top",
              type: "success",
              title: title,
              text: texte,
              showConfirmButton: false,
              timer: 5000
            });
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            let text = 'Une erreur est survenue pendant la création du type, si le problème persiste merci de contacter le support DOSI';
            if (!isEmpty(error) && error.response && error.response.status === 403) {
              text = error.response.data.message;
              self.errors.libelle_technique = 'Libellé technique déjà utilisé';
            }
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000})
          });
      }
    },
    resetForm() {
      this.libelle = '';
      this.libelle_technique = '';
      this.selectedCategory = '';
      // this.selectedType = null;
    },
    clearErrors() {
      this.errors.libelle = '';
      this.errors.libelle_technique = '';
      this.errors.categorie_id = '';
    },
    validateData() {
      this.clearErrors();
      let valid = true;
      if (isEmpty(this.libelle)) {
        this.errors.libelle = 'Le libellé est obligatoire';
        valid = false;
      }
      if (isEmpty(this.libelle_technique)) {
        this.errors.libelle_technique = "Le libellé technique est obligatoire";
        valid = false;
      }
      if (isEmpty(this.selectedCategory)) {
        this.errors.categorie_id = "La catégorie est obligatoire";
        valid = false;
      }
      return valid;
    },
  }
}
</script>
<style scoped>
</style>